import Login from './login'

/**
 * Authentication pages routes configuration
 */

const routes = [
    {
        key: 'login_page',
        path: '/',
        exact: true,
        component: Login
    }
]

export default routes 